import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { connect } from 'react-redux';
import { IBienSV, IAuthReduxProps, ITarget, IVente } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { deOrSvBien } from '../../flux/actions/bienActions';
import { getUsers } from '../../flux/actions/userActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faExternalLinkAlt, faPen, faSpinner, faCheckCircle, faLock, faLockOpen, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import { getConstanteProjetInfos, getConstanteRecuImageIncrem } from '../../flux/actions/constanteActions';
import { instantUploadToFTP } from '../pdf/PDFLink';
import { constants } from '../../types/constants';
import DatePicker from "reactstrap-date-picker";
import ReactTooltip from 'react-tooltip';

const BienSV = ({
  modal,
  setModal,
  modalData,
  deOrSvBien,
  sv,
  auth
 }: IBienSV) => {
  const [idValue, setIdValue] = useState(-1);
  const [designationValue, setDesignationValue] = useState('');
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);

  const alert = useAlert();
  
  const handleToggle = () => setModal(!modal);

  const modalOpenedHandle = () => {
    if(modalData && modalData !== ''){
      setIdValue(modalData["id"]);
      setDesignationValue(modalData["DESIGNATION"]);
    }
  };

  const modalClosedHandle = () => {
    setIdValue(-1);
    setDesignationValue('');
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const callback = (success, errMsg) => {
    if(success){
      setReEnable(true);
      setModal(false);
      alert.success(`Bien modifié avec succès`);
      return
    }
    alert.error(errMsg || "Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const deOrSvHandle = async () => {
    if(idValue === -1)
      return
    // const isDg = auth?.user?.speciality === constants.ROLE_DG ? 1 : 0;
    // const isDc = auth?.user?.speciality === constants.ROLE_DC ? 1 : 0;
    // if(isDg === 0 && isDc === 0){
    //   alert.error("Action non autorisée")
    //   return
    // }
    setDisableSubmit(true);
    deOrSvBien(idValue, sv, auth?.user?.id, callback);
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faPen} />&nbsp;&nbsp;Simulation de Vente</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  Voulez-vous vraiment <b>{sv ? "faire une simulation de vente" : "enlever la simulation de vente"}</b> pour le bien <b>{designationValue || ""}</b> ?
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Button
                  className={`btn btn-${sv ? "danger" : "warning"} linesConfirmationBtn linesDeleteBtn`}
                  onClick={deOrSvHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : sv ? faLock : faLockOpen} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Valider</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { deOrSvBien, getUsers })(BienSV);
